<template>
    <div class="wrap">
        <el-dialog
            title=""
            :visible.sync="isDetail"
            width="65%"
            :before-close="handleCloseDetail" center>
            <div class="el-row">
            <div class="el-col el-col-4">
                <div class="img_box">
                    <img :src="detail.cover" alt="" class="el-image__inner">
                </div>
                <div class="name">
                    {{detail.name}} <span class="examination_standard">{{detail.audit_standard}}</span>
                </div>
                <div class="leibie ctop">
                    <div class="d1"></div>
                    <div class="d1">
                        <span class="c1" v-for="(direction,index) in detail.direction" :key="index">{{direction}}</span>
                    </div>
                    <div class="d2">
                        <span class="c1">{{detail.level}}/{{detail.cycle}}</span>
                    </div>
                </div>
                <div class="public_date ctop">
                    <span style="font-weight: 600;">出刊时间: </span>
					<span>{{detail.date}} {{detail.date_type}}</span>
                </div>
                <div class="pici ctop">
                    <span style="font-weight: 600;">批次:</span>{{detail.science_periodical}}
                </div>
                <div class="network ctop">
                    <span style="font-weight: 600;">上网情况: </span>
					<span v-for="(net,index) in detail.included_database" :key="index">{{net}}</span>
                </div>
                <div class="current_date ctop">
                    <span style="font-weight: 600;">当前刊期:</span>
					<span>{{detail.current.content}}</span>
                </div>
            </div>

            <div class="el-col el-col-9">
                <div class="div1">
                    <div role="button" class="el-collapse-item__header is-active activeheader">
                        &nbsp;&nbsp; 基本信息 <!---->
                    </div>
                    <div class="basic_context transition_dom fullheight">
                        <div style="padding: 5px 10px;" v-for="(price,index) in detail.price" :key="index">
                            <span style="font-weight: 600;">{{price.role}}:</span><span>{{price.price}}元</span>
                        </div>
                        <div index="1-1">
                            <span style="font-weight: 600;">国内刊号:</span>
							<span>{{detail.domestic_number}}</span>
                        </div>
                        <div index="1-2">
                            <span style="font-weight: 600;">国际刊号:</span>
							<span>{{detail.international_number}}</span>
                        </div>
						<div index="1-5">
						    <span style="font-weight: 600;">邮发代号:</span>
							<span>{{detail.post_code}}</span>
						</div>
						<div index="1-5">
						    <span style="font-weight: 600;">主管单位:</span>
							<span>{{detail.management}}</span>
						</div>
						<div index="1-4">
						    <span style="font-weight: 600;">主办单位:</span>
							<span>{{detail.organizer}}</span>
						</div>
						<div index="1-4">
						    <span style="font-weight: 600;">版面字符:</span>
							<span>{{detail.char_count}}</span>
						</div>
						<div index="1-6">
						    <span style="font-weight: 600;">封面核心: </span><span>{{detail.cover_core | formatcore}}</span>
						</div>
						<div index="1-7">
						    <span style="font-weight: 600;">影响因子: </span><span>{{detail.impact_factor | formatcore}}</span>
						</div>
						<div index="1-18">
						    <span style="font-weight: 600;">刊物栏目:</span><span>{{detail.column}}</span>
						</div>
                        <div index="1-18">
                            <span style="font-weight: 600;">收稿要求:</span>
							<span>{{detail.annex_info}}</span>
                        </div>
                        <div index="1-10">
                            <span style="font-weight: 600;">页码:</span>
							<span>{{detail.page}}页</span>
                        </div>

                        <div index="1-2">
                            <span style="font-weight: 600;">审稿难度：</span>
							<span>{{detail.audit_standard}}</span>
                        </div>

                        <!-- <div index="1-8">
                            样刊:<span>{{detail.simple}}</span>
                        </div>

                        <div index="1-11">
                            查重率:<span>{{detail.page_remark}}</span>
                        </div>
                        <div index="1-12">
                            省市邮编:<span>{{detail.postcode}}</span>
                        </div>
                        <div index="1-12">
                            摘要关键字:<span>{{detail.summary_keywords}}</span>
                        </div>
                        <div index="1-13">
                            作者简介:<span>{{detail.author_info}}</span>
                        </div>
                        <div index="1-14">
                            参考文献:<span>{{detail.references}}</span>
                        </div>
                        <div index="1-15">
                            审稿难度:<span>{{detail.review_difficulty}}</span>
                        </div>
                        <div index="1-16">
                            审稿时长:<span>{{detail.review_time}}</span>
                        </div>

                        <div index="1-19">
                            附件信息:<span>{{detail.remark}}</span>
                        </div> -->
                    </div>
                </div>
            </div>

			<div class="first-model el-col el-col-9">
			    <div class="div1">
			        <div role="button" class="el-collapse-item__header is-active activeheader">
			            &nbsp;&nbsp;期次信息 <!---->
			        </div>
              <div class="fullheight">
              <div class="recode transition_dom" v-for="(a,b) in history_list" :key="b">
                  <div left-index="">
                      <p class="style1" style="font-size: 14px;font-weight: 600;">
                          {{a}}年记录
                      </p>
                  </div>
                  <div v-for="(h,index) in detail.history" :key="index" v-if="a===h.created_at">
                      <!-- <div words="" >
                          <p s="style3" class="style2">
                              {{h.date | toMonth}}月记录：
                          </p>
                      </div> -->
                      <div left-index="">
                          <p class="style2">
                              {{h.data}}
                          </p>
                      </div>
                  </div>
              </div></div>
			    </div>
			</div>
        </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
  name: 'login',
  props: {
    detail: {
      type: Object,
      default: {}
    },
    isDetail: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    history_list () {
      let data = []
      this.detail.history.forEach(function (e, i) {
        if (!data.includes(e.created_at)) {
          data.push(e.created_at)
        }
      })
      console.log(data)
      return data
    }
  },
  filters: {
    toMonth (v) {
      let time = new Date(v * 1000)
      return 1 + time.getMonth()
    },
    year (v) {
      return v.substr(0, 4)
    },
    formatcore (v) {
      return v == 1 ? '是' : '无'
    }
  },
  data () {
    return {

    }
  },
  methods: {
    handleCloseDetail () {
      this.$emit('detailVisible', false)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .el-row{
      height: 65vh;
      padding-left: 1%;
      padding-top: 1.5%;
      padding-bottom: 2%;
    }
    .wrap {
      background:#FCFCFC;
      width: 100%;
      /* height: 100vh; */
      position: relative;
    }

    .wrap .el-col-4 {
      padding: 12px;
    }

    .wrap .el-col-4 span {
      /*font-size: 14px;*/
      font-family: SourceHanSansSC;
      color: #5E5E5E;
    }
    .right{
      width: 77%;
    }
    .wrap .el-col-10{
      margin-top: 10px;
      box-sizing: border-box;
      border-radius: 15px;
      position: relative;
      background: #fff;
      width: 37%;
      height: 98%;
      box-shadow: 6px 6px 18px #ebebeb;
    }
    .wrap .el-col-4{
      width: 21%;
    }
    .wrap .el-col-4 .img_box {
      width: 100%;
      /*height:302px;*/
      padding-bottom: 10px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 10px rgba(191, 191, 191, 0.2);
      opacity: 1;
      border-radius: 8px;
      margin-bottom: 10px;
    }

    .wrap .el-col-4 .img_box img {
      width: 85%;
      margin: 0 auto;
      display: block;
      height: auto;
    }

    .text_detail {
      width: 100%;
      height: 302px;

    }

    .name {
      height: 42px;
      font-size: 15px;
      font-family: SourceHanSansSC;
      line-height: 42px;
      color: rgba(45, 45, 45, 1);
      opacity: 1;
    }

    /* .wrap .el-col-4 div.leibie {
      border-el-col-4: 2px solid #4CADD3;
      padding-el-col-4: 5px;
    } */

    .wrap .el-col-4 div.leibie span {
      font-family: SourceHanSansSC;
      color: #4CADD3;
      font-size: 14px;
    }

    .wrap .el-col-4 .c1 {
      font-size: 14px;
      font-family: SourceHanSansSC;
      color: rgba(94, 94, 94, 1);
    }

    .wrap .el-col-4 .ctop {
      margin: 5px auto;
      font-size: 14px;
      font-family: SourceHanSansSC;
    }

    .wrap .el-col-10.basicmsg {
      width: 95%;
      /*height: 50%;*/
      margin: 0 auto;

      border-radius: 10px;
      overflow: hidden;
      margin-bottom: 10px;
    }

    .style2 {
      color: #5E5E5E;
      font-size: 14px;
      font-family: SourceHanSansSC;
      font-weight: normal;

    }
    .basic_context{
      font-size: 14px;
      font-weight: 500;
      font-family: SourceHanSansSC;
    }
    .basic_context span{
      color: #5E5E5E;
      font-size: 14px;
      font-family: SourceHanSansSC;
      font-weight: normal;
    }

    [s] {
      color: #4CADD3 !important;
    }

    [v-cloak] {
      display: none;
    }

    .el-collapse-item__content {

      height: 550px !important;
      overflow-y: auto;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE 10+ */
    }

    .el-collapse-item__content::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }

    .el-collapse-item__content div {
      font-weight: bold;
      font-size: 14px;

    }

    .el-collapse-item__content div span {
      font-weight: normal;
      font-size: 13px;
    }

    .el-collapse-item__header {
      padding-right: 15px;
      font-size: 15px;
      padding: 0px 10px;
      color:rgba(45,45,45,1);
      position: relative;
    }
    .after::after{
      content: "";
      position: absolute;
      width: 96%;
      top: 48px;
      border:0.5px solid rgba(221,221,221,1);
    }

    .is-active .el-collapse-item__header {
      background: linear-gradient(90deg, rgba(51, 146, 168, 1) 0%, #4CADD3 100%) !important;
      box-shadow: 0px -3px 16px rgba(191, 191, 191, 0.2) !important;
      border-radius: 6px 6px 0px 0px !important;
      color: white;
    }
    .div1 {
      height:92%;
      border-radius:10px;
    }

    .transition_dom {
      transition: all 0.3s linear 0s;
    }

    .activeheader {
      background: #4CADD3;
      box-shadow: 0px -3px 16px rgba(191,191,191,0.2) !important;
      color: white;
      padding: 0px 10px;
      border-radius: 10px 10px 0 0;
    }
    [index]{
      padding: 5px 10px;
    }
    .activefix{
      position: fixed;
      width: 73.7%;
      border-radius: 10px 10px 0px 0px;
    }
    .active  .recode,.active .basic_context{
      padding-top: 55px;
    }
    .btn_detail{
      position: absolute;
      right:5%;
    }
    .fullheight{
      height:55vh;
      overflow-y: auto;
      scrollbar-width: none;
      -ms-overflow-style: none;
    }
    .clear{
      clear: both;
    }
    .el-col-4  {
      height: 55vh;
      overflow: scroll;
    }
    .transition_dom{
      overflow: scroll;
      scrollbar-width: none;
      -ms-overflow-style:none
    }
    ::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
    .first-model{
      margin-right: 2% !important;
      margin-left: 1%;
    }
    [left-index]{
      padding: 3px 10px;
    }
    [words]:not(:first-child){
      padding: 4%  10px 0 10px;
    }
    .examination_standard{
      font-family: SourceHanSansSC;
      color: #4CADD3 !important;
      font-size: 14px !important;
      padding-left:15px;
    }
    .name{
      line-height: normal !important;
      height: auto !important;
    }
	p{
		margin: 1px !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/detail/Detail.vue